// API Configuration
// Supports environment variable override: REACT_APP_API_URL or NEXT_PUBLIC_API_URL
// For local testing, create .env.local with: REACT_APP_API_URL=http://localhost:5001/api
export const API_BASE_URL = process.env.REACT_APP_API_URL || process.env.NEXT_PUBLIC_API_URL || 'https://api.bioskar.com/api';
export const API_TIMEOUT = 10000; // 10 seconds

// Carousel Configuration
export const CAROUSEL_INTERVAL = 5000; // 5 seconds
export const CAROUSEL_TRANSITION_DURATION = 2000; // 2 seconds

// Form Configuration
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const MIN_MESSAGE_LENGTH = 10;
export const MAX_MESSAGE_LENGTH = 1000;

// Error Messages
export const ERROR_MESSAGES = {
  NETWORK_ERROR: 'Unable to connect. Please check your internet connection.',
  TIMEOUT_ERROR: 'Request timed out. Please try again.',
  SERVER_ERROR: 'Something went wrong. Please try again later.',
  VALIDATION_ERROR: 'Please check your input and try again.',
  GENERIC_ERROR: 'An unexpected error occurred. Please try again.',
} as const;

// Success Messages
export const SUCCESS_MESSAGES = {
  CONTACT_SENT: 'Thank you! Your message has been sent successfully.',
  SUBSCRIBED: 'Successfully subscribed! Check your email for confirmation.',
} as const;
